import React from 'react';
import classnames from 'classnames/bind';
import Reveal from '../../ui/Reveal/Reveal';
import styles from './Capabilities.module.scss';

const cx = classnames.bind(styles);

interface ICapability {
    domain: string;
    name: string;
    text: string;
}

const CAPABILITIES: ICapability[] = [
    {
        domain: 'feed',
        name: 'Reads the room',
        text: 'Scans your feed and notifications every day and understands what each post actually says before deciding whether to act.',
    },
    {
        domain: 'engage',
        name: 'Comments with substance',
        text: 'Joins conversations where your people already are, with sharp comments written in your voice — never generic filler.',
    },
    {
        domain: 'network',
        name: 'Grows the right network',
        text: 'Finds the people who match your ideal audience, connects with them and keeps those relationships warm.',
    },
    {
        domain: 'outreach',
        name: 'Opens conversations',
        text: 'Drafts posts and direct messages aimed at your goal, timed for the moment they will land best.',
    },
    {
        domain: 'memory',
        name: 'Remembers everyone',
        text: 'Keeps a running read on every contact — what they care about, how the relationship is evolving, when to follow up.',
    },
    {
        domain: 'learning',
        name: 'Gets sharper every week',
        text: 'Every interaction feeds back into the brain. Your voice, your judgment, what works — it learns and improves on its own.',
    },
];

export default function Capabilities() {
    return (
        <section className={cx('Section')} id='capabilities'>
            <div className={cx('Inner')}>
                <Reveal>
                    <p className={cx('Eyebrow')}>Under the hood</p>
                    <h2 className={cx('Title')}>
                        A self-learning AI brain <em>with hands on the controls.</em>
                    </h2>
                    <p className={cx('Lead')}>
                        Shadowpilot runs on an autonomous actor engine that uses the internet the
                        way a person does — a real browser, email, web search — organized into
                        domains, each with its own capabilities.
                    </p>
                </Reveal>

                <div className={cx('Grid')}>
                    {CAPABILITIES.map((capability, i) => (
                        <Reveal key={capability.domain} delay={i * 0.06} className={cx('Card')}>
                            <span className={cx('Domain')}>{capability.domain}</span>
                            <h3 className={cx('Name')}>{capability.name}</h3>
                            <p className={cx('Text')}>{capability.text}</p>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
